import type { CSSProperties } from "react";
import { reactSelectSMStyle } from "Utils/Common";
import type { PlateSlot } from "./plateSetup96";

export type PlateSetupRecord = {
  id: string;
  plateSetupId?: number;
  rowStatus?: boolean;
  // testType: string;
  panelId?: number | null;
  panelName?: string | null;
  panel: string;
  templateId?: number | null;
  template: string;
  mappingTypeId?: string | null;
  mappingType: string;
  plateTypeId: string;
  plateType: string;
  accessionsPerPlate: number;
  slots: PlateSlot[];
};

export type LookupOption = {
  value: string;
  label: string;
};

/** CompendiumMapping /row.tsx */
export const inputStyles: CSSProperties = {
  border: "1px solid #D3D3D3",
  borderRadius: "16px",
  padding: "14px 16px",
  height: "38px",
  fontSize: "14px",
  color: "#3F4254",
  boxShadow: "none",
  width: "100%",
};

export const fullWidthSelectStyles = {
  ...reactSelectSMStyle,
  control: (base: any) => ({
    ...(reactSelectSMStyle.control
      ? (reactSelectSMStyle.control as (base: any) => any)(base)
      : base),
    width: "100%",
    minWidth: "100%",
  }),
};

export function accessionsForPlateType(plateTypeId: string, plateTypeLabel = ""): number[] {
  const id = String(plateTypeId ?? "").toLowerCase();
  const label = String(plateTypeLabel ?? "").toLowerCase();
  if (id.includes("384") || label.includes("384")) {
    return [24, 48];
  }
  if (id.includes("96") || label.includes("96")) {
    return [2, 3, 4, 6, 12];
  }
  // fallback: use label/id to decide, default to 96-well options
  return [2, 3, 4, 6, 12];
}

export function accessionSelectOptions(plateTypeId: string, plateTypeLabel = "") {
  return accessionsForPlateType(plateTypeId, plateTypeLabel).map((n) => ({
    value: n,
    label: String(n),
  }));
}

export function createId() {
  return `ps-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export const initialSearch = {
  // runName: "",
  panelId: "",
  outputTemplate: "",
  mappingTypeId: "",
  plateTypeId: "",
  noOfAccessionId: "",
};

export type PlateSetupSearchFilters = typeof initialSearch;

export const PLATE_FILTER_FIELDS: (keyof PlateSetupSearchFilters)[] = [
  // "runName",
  "panelId",
  "outputTemplate",
  "mappingTypeId",
  "plateTypeId",
  "noOfAccessionId",
];

export const PLATE_FILTER_LABELS: Record<keyof PlateSetupSearchFilters, string> = {
  // runName: "Test Type",
  panelId: "Panel",
  outputTemplate: "Template",
  mappingTypeId: "Mapping Type",
  plateTypeId: "Plate Type",
  noOfAccessionId: "No. of Accessions in 1 plate",
};

export const ID_LIS_MODULE_NAME = "ID LIS";
export const PLATE_SETUP_PERMISSION_PAGE = "Plate Setup";
export const CREATE_PLATE_TEMPLATES_PERMISSION = "CreatePlateTemplate";

